import './index.scss';
import 'components/filter_form/desktop_toggle';
import 'components/filter_form/footer';
import 'components/filter_form/header';
import 'components/filter_form/toggle';
import 'components/select';
import 'styles/components/_input-groups.scss';
import FilterFormTracker from './options/track';
import QueryString from 'utils/query_string';
import omit from 'lodash/omit';
import pick from 'lodash/pick';
import { EventManager } from 'utils/event_manager';
import { MediaQuery } from 'utils/media_query';

class FilterForm {
  constructor($form, options) {
    jQuery.event.special.filterFormToggle = {
      noBubble: false
    };

    this.$form = $form;
    this.track = options.track;
    this.trackDataLayer = options.trackDataLayer;
    this.$toggle = $('.js-filter-form-toggle');
    this.bindAll();
  }

  bindAll() {
    if (this.track) {
      this.bindFormTracker();
    }

    if (this.trackDataLayer) {
      this.bindFormTrackerDataLayer();
    }

    this.bindFilterFormActions();
    this.bindFilterFormActionButtons();
    this.bindFilterFormToggle();
    this.bindFilterFormToggleButton();
    this.bindSelects();
  }

  bindSelects() {
    $('.q-select-input', this.$form).each((i, el) => {
      $(el).qselect();
    });
  }

  bindFilterFormActions() {
    this.$form.on('change', 'input:not([data-no-summary])', () =>
      this.toggleFilterFormActionButtons()
    );
    EventManager.subscribe('autofillByQueryString.applied', () =>
      this.toggleFilterFormActionButtons()
    );
    $(document).on('filterFormToggle', () => this.toggleFilterFormToggle());
  }

  bindFilterFormActionButtons() {
    this.toggleFilterFormActionButtons();

    $('.js-btn-clean', this.$form).on('click', () => {
      this.$form.clearForm();
      return false;
    });
  }

  bindFormTracker() {
    this.$form.on('submit', () => {
      const { filterName } = this.$form.data();
      const data = new FilterFormTracker(this.$form).parse();

      if (!filterName || Object.keys(data).length === 0) {
        return;
      }

      const notHasFilterQuestions = filterName !== 'questions';

      UserTracker.emit('event', {
        eventName: `${filterName} searched`,
        data,
        ...(notHasFilterQuestions && { except: ['user'] })
      });
    });
  }

  bindFormTrackerDataLayer() {
    this.$form.on('submit', () => {
      const data = new FilterFormTracker(this.$form).json();
      const { filterName } = this.$form.data();
      const permmittedFilters = Object.keys(
        pick(this.$form.serializeObject(), [
          'scholarity_ids',
          'examining_board_ids',
          'institute_ids'
        ])
      );

      if (
        !filterName ||
        filterName !== 'questions' ||
        permmittedFilters.length === 0
      ) {
        return;
      }

      window['dataLayer'].push({
        event: 'questions_filter',
        ...(permmittedFilters.includes('scholarity_ids') && {
          level: data.scholarity_ids.join(',')
        }),
        ...(permmittedFilters.includes('examining_board_ids') && {
          examining_board: data.examining_board_ids.join(',')
        }),
        ...(permmittedFilters.includes('institute_ids') && {
          institution: data.institute_ids.join(',')
        })
      });
    });
  }

  bindFilterFormToggle() {
    this.$toggle.on('change', () => {
      const checked = this.$toggle.is(':checked');

      if (checked) {
        $('body').addClass('q-no-scroll');
      } else {
        $('body').removeClass('q-no-scroll');
      }
    });
  }

  bindFilterFormToggleButton() {
    const $toggleButton = $('.js-filter-form-toggle-btn');

    if ($toggleButton.length) {
      const text = this.areFiltersApplied()
        ? $toggleButton.data().activeText
        : $toggleButton.data().inactiveText;

      $toggleButton.find('span').html(text);
    }

    $toggleButton.on('click', () =>
      $('#filter-form-toggle').prop('checked', true)
    );
  }

  areFiltersApplied() {
    const params = QueryString.getQueryStringData();
    const isFormNotEmpty = !!Object.keys(
      omit(this.$form.serializeObject(), ['per_page', 'sort'])
    ).length;
    const hasQueryParams = !!Object.keys(omit(params, ['sort', 'per_page']))
      .length;

    return !!(isFormNotEmpty || hasQueryParams);
  }

  toggleFilterFormActionButtons() {
    $('.js-filter-form-actions button', this.$form)
      .not('.js-always-display')
      .each((i, button) =>
        $(button).attr('disabled', !this.areFiltersApplied())
      );

    this.$form
      .find('.js-filter-button')
      .attr('disabled', !this.areFiltersApplied());
  }

  toggleFilterFormToggle() {
    if (MediaQuery.is('md')) {
      return;
    }

    this.$toggle
      .prop('checked', !this.$toggle.prop('checked'))
      .trigger('change');
  }
}

(function ($) {
  'use strict';

  if (!$.fn.filterForm) {
    $.fn.filterForm = function (options = {}) {
      const $form = $(this);
      this.filterFormInstance = new FilterForm($form, options);
      return $form;
    };
  }
})(jQuery);
